
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Monthlycabserviceinpune() {



    const cardData =
    {
        keyword: ' Monthly Cab Service in Pune',
        heading: 'S9 Travels:  Monthly Cab Service in Pune',
        headingDescription: 'S9 Travels offers convenient and reliable Monthly Cab Services in Pune for all your regular travel needs. Whether you need transportation for daily commutes, meetings, or frequent visits to different locations, our monthly cab service is the perfect solution. Enjoy the comfort of our well-maintained vehicles, including spacious and luxury options, tailored to your schedule. With a fixed monthly rate, you can enjoy stress-free travel without worrying about daily bookings or price fluctuations. Our professional drivers ensure timely and safe rides, providing you with the highest level of convenience and reliability.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada is a must-see for history buffs. This grand palace was once the seat of the Peshwa rulers and offers fascinating glimpses into Pune's royal past. The light and sound show in the evening is a popular attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892, this beautiful palace is known for its historical significance, as it served as a prison for Mahatma Gandhi during the Indian independence struggle. The palace is surrounded by lush gardens and serves as a reminder of India’s freedom movement."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located on a hilltop, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. A popular trekking destination, it is also rich in history, having been the site of many battles, including the famous Battle of Sinhagad."
    },
    {
      "title": "Osho Ashram",
      "description": "For those seeking peace and tranquility, the Osho Ashram in Pune is a renowned spiritual retreat. It offers yoga, meditation, and spiritual practices to rejuvenate your mind and body. It’s an ideal place for those looking for a calm and reflective experience."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This ancient rock-cut temple, dedicated to Lord Shiva, is located right in the heart of Pune. Carved out of a single rock, it is a serene and historical place, providing insight into ancient Indian architecture and religion."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses a wide collection of artifacts, including sculptures, paintings, and other cultural exhibits. It showcases the rich artistic heritage of India, with a special emphasis on Maharashtra's traditional art forms."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "For nature lovers and those looking for a peaceful escape, Khadakwasla Dam offers a scenic location to relax. It’s a popular spot for picnics, and you can enjoy the beauty of the surrounding hills and the cool breeze by the water."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known as the heart of Pune's youthful and energetic vibe, Fergusson College Road is a bustling area filled with cafes, bookshops, and vibrant street markets. It’s a great spot to experience Pune’s lively culture and shop for souvenirs."
    },
    {
      "title": "Lal Mahal",
      "description": "A significant historical landmark, Lal Mahal was the residence of Chhatrapati Shivaji Maharaj during his youth. It’s an important monument that offers insights into the life of the great Maratha king."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully landscaped park is a peaceful retreat with lovely walking paths, koi ponds, and traditional Japanese architecture. It's an ideal place for a serene walk or a family outing."
    }
],

"services": [
    {
      "name": "Pune Monthly Cab Service",
      "description": "Need a reliable and cost-effective monthly cab service in Pune? S9 Travels offers flexible monthly cab packages that suit your commuting needs. Whether it's for daily office travel or other regular commutes, we ensure you get reliable and punctual transportation every day."
    },
    {
      "name": "Rent Cabs for Monthly Usage in Pune",
      "description": "Renting a cab for monthly usage in Pune has never been easier. S9 Travels provides convenient rental options that give you the freedom to travel daily without the hassle of booking each time. Choose from our well-maintained fleet for your monthly transport needs."
    },
    {
      "name": "Affordable Monthly Cab Booking in Pune",
      "description": "Looking for an affordable monthly cab booking service in Pune? S9 Travels offers competitive rates on monthly cab bookings to ensure you get the best value for money while enjoying reliable and comfortable transportation every day."
    },
    {
      "name": "Regular Monthly Cabs for Pune Residents",
      "description": "For Pune residents looking for a regular monthly cab service, S9 Travels offers convenient and reliable options to make daily commutes stress-free. Whether you're heading to work, school, or any other regular destination, we’ve got you covered."
    },
    {
      "name": "Pune Monthly Taxi Service",
      "description": "S9 Travels offers a monthly taxi service for those who need a consistent and reliable mode of transportation in Pune. Whether it's for business or personal use, our monthly taxi service ensures you have a comfortable ride every day."
    },
    {
      "name": "Convenient Monthly Cab Rentals in Pune",
      "description": "Experience convenience with S9 Travels' monthly cab rentals in Pune. Rent a cab for a month and enjoy hassle-free travel with the flexibility to book whenever you need it. Perfect for long-term travel or daily commuting at affordable rates."
    },
    {
      "name": "Book Monthly Taxi for Daily Commute in Pune",
      "description": "Booking a monthly taxi for your daily commute in Pune is easy with S9 Travels. Choose a monthly plan and enjoy consistent, timely transportation every day. Whether it's for work or personal use, our monthly taxi service ensures comfort and punctuality."
    },
    {
      "name": "Pune Long-Term Taxi Hire",
      "description": "For long-term taxi hire in Pune, S9 Travels offers flexible options to meet your needs. Whether you need a taxi for a few weeks or months, we provide reliable, well-maintained vehicles and professional drivers to ensure smooth travel throughout your rental period."
    },
    {
      "name": "Monthly Transport Solutions in Pune",
      "description": "S9 Travels provides monthly transport solutions in Pune tailored to your needs. Whether you're looking for personal or corporate transport, our monthly services offer the convenience of regular, reliable, and comfortable travel without the hassle of daily bookings."
    },
    {
      "name": "Corporate Monthly Taxi Rentals in Pune",
      "description": "S9 Travels offers corporate monthly taxi rentals in Pune for businesses looking to provide convenient and reliable transport options for employees. Whether it's for daily commutes or client meetings, we offer flexible, cost-effective solutions for your corporate needs."
    },
    {
      "name": "Pune Monthly Car Rental Options",
      "description": "If you're looking for monthly car rental options in Pune, S9 Travels has you covered. Rent a car on a monthly basis and enjoy the flexibility of choosing a vehicle that suits your travel needs. Our fleet is well-maintained and perfect for both short and long-term rentals."
    }
],

"tableData": [
  ["Pune Monthly Cab Service", "Rent Cabs for Monthly Usage in Pune"],
  ["Affordable Monthly Cab Booking in Pune", "Regular Monthly Cabs for Pune Residents"],
  ["Pune Monthly Taxi Service", "Convenient Monthly Cab Rentals in Pune"],
  ["Book Monthly Taxi for Daily Commute in Pune", "Pune Long-Term Taxi Hire"],
  ["Monthly Transport Solutions in Pune", "Corporate Monthly Taxi Rentals in Pune"],
  ["Pune Monthly Car Rental Options", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Daily Commute",
    "WhyChoosedescription": "With S9 Travels' monthly cab service in Pune, you can rely on us for consistent, on-time service every day. Whether you need a ride to the office or any other regular destination, our drivers ensure punctuality, so you never miss an important commitment."
  },
  {
    "WhyChooseheading": "Affordable Subscription Plans",
    "WhyChoosedescription": "Our monthly cab service offers affordable subscription plans tailored to fit your travel needs. You get the flexibility of daily commutes at a fixed, predictable cost, helping you budget your travel expenses while enjoying high-quality service."
  },
  {
    "WhyChooseheading": "Comfortable Rides Every Day",
    "WhyChoosedescription": "Enjoy the luxury and comfort of our well-maintained Toyota Innova cabs for your daily commute. Spacious seating, air conditioning, and clean interiors make your everyday travel experience comfortable and relaxing, whether you're heading to work or elsewhere."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are well-trained to navigate Pune's busy streets, ensuring a smooth and safe ride every day. With a focus on customer satisfaction, our drivers provide courteous and professional service, making your monthly commute pleasant."
  },
  {
    "WhyChooseheading": "Fixed and Transparent Pricing",
    "WhyChoosedescription": "Our monthly cab service comes with fixed pricing, ensuring there are no surprises. You’ll know exactly what to expect with a transparent breakdown of charges at the time of booking, allowing you to plan your monthly budget with ease."
  },
  {
    "WhyChooseheading": "No Hassle, Just a Convenient Ride",
    "WhyChoosedescription": "With S9 Travels' monthly cab service, you don’t need to worry about last-minute bookings or availability. Enjoy the peace of mind knowing your cab is always ready for your scheduled pick-up, providing a hassle-free travel experience every day."
  },
  {
    "WhyChooseheading": "Customizable Pick-up and Drop-off Locations",
    "WhyChoosedescription": "Whether you need to be picked up from your home, office, or any other location in Pune, we offer customizable pick-up and drop-off points to suit your convenience. Tailor your monthly cab service according to your unique requirements."
  },
  {
    "WhyChooseheading": "24/7 Support for Your Monthly Travel",
    "WhyChoosedescription": "S9 Travels offers round-the-clock support for our monthly cab service. Whether you need to make changes to your schedule or require assistance, our customer service team is available anytime to ensure your travel needs are met seamlessly."
  }
]






    }



    const faqData = [
        [
          {
            question: 'How can I book a monthly cab service in Pune with S9 Travels?',
            answer: 'Booking a monthly cab service is simple! You can book online through our website or app, or get in touch with our customer service team to set up a customized monthly plan based on your requirements.',
          },
          {
            question: 'What are the benefits of opting for a monthly cab service?',
            answer: 'Our monthly cab service offers convenience, flexibility, and cost savings for daily commuting, business travel, or regular appointments. You get a dedicated vehicle and driver at your service for the entire month.',
          },
          {
            question: 'Do you offer discounts for monthly bookings?',
            answer: 'Yes, we offer attractive discounts for monthly bookings, providing you with a more affordable solution for regular travel. Contact our team to learn more about our special rates for monthly services.',
          },
          {
            question: 'Can I choose the vehicle for my monthly cab service?',
            answer: 'Absolutely! You can select from a range of vehicles, including sedans, SUVs, and premium cars like the Toyota Innova, depending on your comfort and travel needs for the month.',
          },
          {
            question: 'Are the drivers experienced and reliable for monthly bookings?',
            answer: 'Yes, all our drivers are professional, experienced, and dedicated to ensuring your comfort and safety throughout the month. They are familiar with your routine and can make your travel as smooth as possible.',
          },
          {
            question: 'How flexible is the monthly cab service for changes in schedule?',
            answer: 'Our monthly cab service is flexible! If your schedule changes, just inform us in advance, and we will adjust the service accordingly to meet your new requirements.',
          },
          {
            question: 'Can I use the monthly cab service for both personal and business trips?',
            answer: 'Yes, you can use the monthly cab service for both personal and business purposes. Whether it’s for daily office commutes or personal errands, we ensure your travel is comfortable and convenient.',
          },
          {
            question: 'Is there a cancellation policy for monthly bookings?',
            answer: 'Yes, we have a cancellation policy for monthly bookings. If you need to cancel or adjust your monthly plan, please inform us within the specified time frame, and we will make the necessary changes.',
          },
          {
            question: 'What is the procedure for making changes to my monthly cab service?',
            answer: 'To make changes to your monthly cab service, simply contact our customer support team. We’ll assist you with modifying your schedule, vehicle choice, or any other aspect of the service as per your needs.',
          },
          {
            question: 'Why should I choose S9 Travels for my monthly cab service in Pune?',
            answer: 'S9 Travels offers a reliable, cost-effective, and flexible monthly cab service with experienced drivers and well-maintained vehicles. We provide a hassle-free travel experience, ensuring you always reach your destination on time and in comfort.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rakesh Mehta',
          designation: 'IT Consultant',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels has been providing excellent monthly cab service for my daily office commute. The vehicle is always on time, the driver is professional, and the service is reliable. I highly recommend their monthly packages for anyone in need of regular travel.”',
        },
        {
          name: 'Mrs. Sunita Agarwal',
          designation: 'Business Owner',
          rating: [1, 1, 1, 1, 1],
          text: '“We’ve been using S9 Travels for our monthly cab service for employee transportation, and the experience has been exceptional. The cabs are clean, comfortable, and the drivers are courteous. It’s a great choice for anyone looking for regular, hassle-free travel.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Monthly Cab Service in Pune",
        "description": "Book affordable monthly cab services in Pune for regular commutes, long-term taxi hire, or corporate needs. Whether you're looking for a convenient taxi rental for daily use or a long-term solution, S9 Travels offers reliable monthly transport options in Pune for residents and businesses alike.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      


    return (
        <div>
        
        <Helmet>
        <title>Monthly Cab Service in Pune | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book monthly cab services in Pune for regular commutes, corporate needs, long-term taxi hire, or daily rentals. Affordable and convenient monthly transport solutions for residents and businesses with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
     
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlycabserviceinpune;